export enum LocalStoreKey {
    FcmSubscription = 'DWS-subscription-fcm-id',
    Notifications = 'notifications-DWS-store',
}
